export enum REPORT_STATUS {
    PENDING = 'PENDING',
    TO_VALIDATE = 'TO_VALIDATE',
    TO_SIGN = 'TO_SIGN',
    VALIDATED = 'VALIDATED',
    SIGNED = 'SIGNED',
    IN_PROGRESS = 'IN_PROGRESS',
}

